import { formatNumberForDisplay, parseNumberForServer } from 'utils/numberUtils'

/**
 * Hook personalizado para manejar inputs numéricos con formato para guaraníes
 * (sin decimales, con separador de miles)
 * 
 * @param {function} onChange - Función a llamar cuando cambie el valor
 * @returns {object} Objeto con handlers para el input
 */
const useNumberInput = (onChange) => {
	// Handler para cuando el usuario escribe en el input
	const handleInputChange = (e) => {
		const inputValue = e.target.value

		// Permitir solo dígitos y puntos (separadores de miles)
		if (inputValue === '' || /^[0-9.]*$/.test(inputValue)) {
			// Normalizar y enviar valor entero al servidor
			const serverValue = parseNumberForServer(inputValue)
			onChange(serverValue)
		}
	}

	// Handler para formatear el valor cuando el input pierde el foco
	const handleBlur = (e) => {
		const inputValue = e.target.value
		if (inputValue === '') {
			return
		}

		// Obtener el valor numérico y formatearlo con separadores de miles
		const serverValue = parseNumberForServer(inputValue)
		const formattedValue = formatNumberForDisplay(serverValue)

		// Actualizar el input con el valor formateado
		e.target.value = formattedValue
	}

	// Formateador para mostrar valores
	const formatDisplayValue = (value) => {
		return formatNumberForDisplay(value)
	}

	return {
		handleInputChange,
		handleBlur,
		formatDisplayValue
	}
}

export default useNumberInput